module.exports = __webpack_public_path__ + "img/pic_category_03_w1200.662a7111.png";